export const GET_CERTIFICATES = 'GET_CERTIFICATES'
export const GET_CERTIFICATE = 'GET_CERTIFICATE'
export const ADD_CERTIFICATE = 'ADD_CERTIFICATE'
export const UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE'
export const DELETE_CERTIFICATE = 'DELETE_CERTIFICATE'
export const GENERATE_CERTIFICATE = 'GENERATE_CERTIFICATE'
export const GET_FILE_TYPES = 'GET_FILE_TYPES'
